export type TypingActivityType = "START_TYPING" | "STOP_TYPING";

/**
 * Which typing frame, if any, a composer value change should broadcast.
 *
 * `previousValue` is what this composer last observed — seeded at mount with the
 * restored draft — so a remount after a refetch, a socket reconnect, or any
 * re-render that re-presents the same text resolves to `null` and stays off the
 * wire. Only a real change to the text is typing.
 */
export function resolveTypingTransition(
  previousValue: string,
  nextValue: string,
): TypingActivityType | null {
  if (previousValue === nextValue) return null;
  return nextValue === "" ? "STOP_TYPING" : "START_TYPING";
}
